import { useEffect, useState } from "react";
import { useAuth, useMerchantApiQuery } from "../hooks";

import { IBalancesContext, IViewBalance } from "../interfaces-and-types";
import { BalancesContext } from "./BalancesContext";

export function BalancesProvider({ children }: { children: React.ReactNode }) {
  const { is_logged_in } = useAuth(); // to prevent checkout page from requesting balances
  const [debouncePeriodElapsed, setDebouncePeriodElapsed] =
    useState<boolean>(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setDebouncePeriodElapsed(true), 100);

    return () => clearTimeout(timeoutId);
  }, []);

  const { isSuccess, isError, isLoading, data, refetch } = useMerchantApiQuery<
    IViewBalance[]
  >("getBalances", {
    enabled: is_logged_in && debouncePeriodElapsed,
    // refetchInterval: appConfig.balancesQueryCacheIntervalInMins, // CAUTION: causes constant refetchBug in AppHeader
  });

  const [activeBalanceCurrency, setActiveBalanceCurrency] = useState<
    string | null
  >(null);

  useEffect(() => {
    if (isSuccess) {
      // if (activeBalanceCurrency === null) {
      if (data && data?.length > 0) {
        const defaultCurrency = data.find(
          (bal) => bal.is_local_currency_balance
        );

        setActiveBalanceCurrency(defaultCurrency?.currency || data[0].currency);
      }
      // }
    }
  }, [isSuccess]);

  const refreshRemoteData = () => {
    refetch();
  };

  // const memoedBalancesContext = useMemo(() => {
  const unMemoedBalancesContext: IBalancesContext = {
    // active balance
    activeBalanceCurrency,
    setActiveBalanceCurrency,

    // remote context
    isSuccess,
    isError,
    isLoading,
    data: data || [],
    refreshRemoteData,
  };

  //   return unMemoedBalancesContext;
  // }, [isSuccessBalances, isRefreshing, data?.length]);

  return (
    <BalancesContext.Provider value={unMemoedBalancesContext}>
      {children}
    </BalancesContext.Provider>
  );
}
